import {BodySite, Pathology} from '@legit-health/ui';
import {Condition, ConditionApiResponse} from '../interfaces/Condition';

export default function mapResponseToCondition({
  condition,
  bodySitesById,
  pathologiesById
}: {
  condition: ConditionApiResponse;
  bodySitesById: Record<number, BodySite>;
  pathologiesById: Record<number, Pathology>;
}) {
  return new Condition(
    condition.id,
    bodySitesById[condition.bodySite] as BodySite,
    pathologiesById[condition.pathology] as Pathology,
    condition.practitioner,
    condition.frequency,
    condition.isTracked,
    condition.assigmentSource,
    condition.firstImage,
    condition.firstImageThumbnail,
    condition.createdAt,
    condition.firstImageOfPerspective,
    condition.scoringSystemsFirstResults,
    condition.canBeTracked
  );
}
